<template>
    <div>
        <div class="container-fluid container-fluid--bg-red edge--bottom">
            <div class="row">
                <div class="col-sm">
                    <transition-group appear name="fade" :duration="100">
                        <h1 :key="title">{{ title }}</h1>
                    </transition-group>
                </div>
            </div>
        </div>
        <section class="container container--bg-white container--negative-top-margin container--border-radisu-small">
          <div class="row">
            <div class="col">
              <p>Content coming soon...</p>
            </div>
          </div>
        </section>
    </div>
</template>

<script>

export default {
    name: 'Templates',
    data() {
        return {
            title: 'Marketing Templates'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
